import { Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, Stack, TextField } from "@mui/material";
import { useCallback, useEffect, useReducer, useState } from "react";
import api, { SystemSettingsDto } from "../../../api";
import { TabPanel } from "../../controls";
import { SmtpSettingsControl } from "../../settings";
import { createStateReducer, notif } from "../../utils";

export const SettingsPage = () => {
  const reducer = createStateReducer<SystemSettingsDto>();
  const [current, setCurrent] = useState("");
  const [changed, setChanged] = useState(false);
  const [state, dispatch] = useReducer(reducer, null);

  const onSave = async () => {
    try {
      const settings = await api.systemSettings.update(state as any);
      setCurrent(JSON.stringify(settings));
      dispatch({ state: settings });
    } catch (err) {
      notif(err, "error");
    }
  };
  const onReset = useCallback(async () => {
    let settings = await api.systemSettings.get();
    if (!settings) {
      settings = {
        isSchedulerEnabled: false,
        schedulerTimes: "",
        smtp: {} as any,
        twoCaptchaApiKey: "",
      } as any;
    }
    setCurrent(settings ? JSON.stringify(settings) : "");
    dispatch({ state: settings, replace: true });
  }, []);

  const onChange = (dto: Partial<SystemSettingsDto>) => {
    dispatch({ state: dto });
  };

  useEffect(() => {
    const stateJson = state ? JSON.stringify(state) : "";
    setChanged(stateJson !== current);
  }, [state]);

  useEffect(() => {
    onReset();
  }, [onReset]);

  const tabSettings = () => (
    <Box maxWidth="600px">
      <FormGroup>
        <FormControlLabel label="Scheduler enabled" control={<Checkbox checked={state?.isSchedulerEnabled ?? false} onChange={(e, c) => onChange({ isSchedulerEnabled: c })} />} />
        <TextField label="Scheduler times" variant="standard" value={state?.schedulerTimes ?? ""} onChange={(e) => onChange({ schedulerTimes: e.target.value })} />
        <br />
        <Box maxWidth="300px">
          <Divider />
          <SmtpSettingsControl settings={state?.smtp ?? ({} as any)} onChange={(value) => onChange({ smtp: value as any })} />
          <Divider />
        </Box>
        <br />
        <TextField label="2Captcha ApiKey" variant="standard" value={state?.twoCaptchaApiKey ?? ""} onChange={(e) => onChange({ twoCaptchaApiKey: e.target.value })} />
      </FormGroup>
      <br />
      <Stack spacing={2} direction="row">
        <Button disabled={!changed} variant="contained" onClick={onSave}>
          Save
        </Button>
        <Button disabled={!changed} variant="contained" onClick={onReset}>
          Reset
        </Button>
      </Stack>
    </Box>
  );

  return (
    <Box>
      <TabPanel name="settings" items={[{ label: "SYSTEM SETTINGS", children: tabSettings() }]} />
    </Box>
  );
};
